import { Bindings } from "booking_app/types";

declare var angular: any;

export class PriceBreakdownLinkController {
  static $inject = ["$modal"];

  data: any;
  type: "hotel" | "booking";
  selectAction: () => void;

  constructor(private $modal: any) {}

  showPriceBreakdown(event: MouseEvent) {
    event.stopPropagation();
    event.preventDefault();
    this.$modal.open({
      animation: true,
      templateUrl: "/html/modals/price_breakdown_modal",
      controller: "PriceBreakdownModal",
      controllerAs: "popup",
      size: "sm",
      windowClass: "price-breakdown-modal",
      resolve: {
        data: () => this.data,
        type: () => this.type,
        selectAction: () => this.selectAction(),
      }
    });
  }

  hasPriceBreakdown() {
    if (this.type === "hotel") {
      return this.data.included_taxes_and_fees?.length > 0;
    }
    return this.data.price_breakdown_metadata?.included_taxes_and_fees?.length > 0;
  }
}

angular.module("BookingApp").component("priceBreakdownLink", {
  bindings: {
    data: Bindings.ONE_WAY,
    type: Bindings.ONE_WAY,
    selectAction: Bindings.EXPRESSION,
  },
  controller: PriceBreakdownLinkController,
  template: `
    <div class="price-breakdown" ng-click="$ctrl.showPriceBreakdown($event)" ng-if="$ctrl.hasPriceBreakdown()">
      <span class="label">Price breakdown</span>
      <i class="icon fa fa-info-circle" style="display: inline-block"></i>
    </div>
  `
});
